var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseTemplate',[_c('TabBar',{on:{"clickLogin":function($event){_vm.formMode = 1},"clickRegister":function($event){_vm.formMode = 2}}}),(_vm.formMode == 1)?_c('Login'):_vm._e(),(_vm.formMode == 2)?_c('MemberSave'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }